import Navbar from "./Navbar";
import "./Navbar.css";

export default function Layout({ children }) {
  return (
    <div className="layout">
      <Navbar />
      <main className="main-content">{children}</main>
    </div>
  );
}